import { render, staticRenderFns } from "./jd-file-upload.vue?vue&type=template&id=dc502ffe&scoped=true&"
import script from "./jd-file-upload.vue?vue&type=script&lang=js&"
export * from "./jd-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./jd-file-upload.vue?vue&type=style&index=0&id=dc502ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc502ffe",
  null
  
)

export default component.exports